import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { QuestionMarkIcon } from '@treams/treams-icons';
import { Callout, Paragraph } from '@treams/treams-ui';
import { useMixpanel } from 'packages/kakapo-ui-application/hooks/useMixpanel';

const LoginAttemptCard = () => {
	const { t } = useTranslation('', { keyPrefix: 'onboarding.loginAttemptCard' });
	const mixpanel = useMixpanel();

	return (
		<Callout color="blue" icon={<QuestionMarkIcon />} mt={4}>
			<Paragraph>
				<Trans
					t={t}
					i18nKey={'description'}
					values={{ link: t('link') }}
					components={{
						linkTag: (
							<StyledLink
								onClick={() => mixpanel?.track('signup.cancel.login')}
								id="signup.loginLink"
								href="https://login.ontreams.com/"
								target="_blank"
							/>
						),
					}}
				/>
			</Paragraph>
		</Callout>
	);
};

const StyledLink = styled.a`
	text-decoration: underline;
	font-weight: bold;
`;

export default LoginAttemptCard;
